import { Phone, Mail, ShieldCheck } from "lucide-react";
import { AGENT_REG, PROJECT_PHASE_1, PROJECT_PHASE_2 } from "../data/site";
import { LeadForm } from "./LeadForm";
import { Reveal, SectionHeading } from "./Reveal";

export const ContactFooter = ({ phone, whatsapp }) => (
  <>
    <section id="contact" data-testid="contact-section" className="py-20 sm:py-28 bg-[#F4FAE8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <SectionHeading index="10" eyebrow="Contact" title="Begin with a conversation" />
          <Reveal delay={0.15}>
            <p className="mt-6 text-[#4D7C0F] text-base sm:text-lg leading-relaxed max-w-xl">
              Tell us what you're looking for — configuration, budget or a preferred visit date — and a Forest Hill
              Realtors advisor will respond with the latest price and availability for Vinayak 21 Acres.
            </p>
            <div className="mt-8 space-y-4">
              <a href={`tel:${phone}`} data-testid="contact-call-link" className="flex items-center gap-4 text-[#365314] group">
                <span className="w-11 h-11 rounded-full border border-[#84CC16]/40 bg-white flex items-center justify-center group-hover:bg-[#84CC16] group-hover:text-[#365314] transition-all duration-300">
                  <Phone size={17} strokeWidth={1.7} />
                </span>
                <span className="font-sub font-medium">{phone}</span>
              </a>
              <a href="mailto:foresthilrealtor@gmail.com" data-testid="contact-email-link" className="flex items-center gap-4 text-[#365314] group">
                <span className="w-11 h-11 rounded-full border border-[#84CC16]/40 bg-white flex items-center justify-center group-hover:bg-[#84CC16] group-hover:text-[#365314] transition-all duration-300">
                  <Mail size={17} strokeWidth={1.7} />
                </span>
                <span className="font-sub font-medium text-sm sm:text-base">foresthilrealtor@gmail.com</span>
              </a>
              <div className="flex items-center gap-4 text-[#365314]">
                <span className="w-11 h-11 rounded-full border border-[#84CC16]/40 bg-white flex items-center justify-center">
                  <ShieldCheck size={17} strokeWidth={1.7} />
                </span>
                <span className="font-mono-spec text-xs sm:text-[13px]">WBRERA Agent Reg. {AGENT_REG}</span>
              </div>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-6">
          <div className="bg-white border border-[#DCECC0] rounded-2xl p-6 sm:p-9 shadow-[0_24px_48px_-24px_rgba(77,124,15,0.18)]">
            <LeadForm source="Contact Section" testIdPrefix="contact-lead-form" whatsapp={whatsapp} />
          </div>
        </Reveal>
      </div>
    </section>

    <Footer />
  </>
);

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-[#EAF5D6] text-[#4D7C0F] pt-16 pb-28 md:pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-8 pb-10 border-b border-[#84CC16]/25">
          <div>
            <p className="font-serif-display text-2xl text-[#3F6212]">
              Forest Hill <span className="italic text-[#84CC16]">Realtors</span>
            </p>
            <p className="text-xs mt-3 leading-relaxed max-w-sm">
              Authorised Channel Partner for Vinayak 21 Acres. WBRERA Registered Real Estate Agent.
            </p>
          </div>
          <div className="font-mono-spec text-[11px] leading-loose tracking-wide">
            <p>Agent Reg: {AGENT_REG}</p>
            <p>Project Phase 1: {PROJECT_PHASE_1}</p>
            <p>Project Phase 2: {PROJECT_PHASE_2}</p>
          </div>
        </div>
        <p className="text-[11px] leading-relaxed text-[#65A30D] pt-8 max-w-5xl" data-testid="footer-disclaimer">
          <strong className="text-[#84CC16]">Disclaimer:</strong> This website is operated by Forest Hill Realtors, an
          authorised channel partner and WBRERA-registered real estate agent, and is not the official website of the
          project promoter/developer. Project information, plans, specifications, amenities, timelines, pricing and
          availability are subject to change and should be independently verified. Prospective purchasers should refer
          to the WBRERA website, official project documents and Agreement for Sale for complete and updated
          information. The name "Vinayak 21 Acres" does not necessarily represent the actual land area of the
          project/phase. Nothing on this website constitutes a guaranteed investment return.
        </p>
        <p className="text-[11px] text-[#65A30D] mt-6">© {new Date().getFullYear()} Forest Hill Realtors · foresthillrealtors.com</p>
      </div>
    </footer>
);
